import { render, staticRenderFns } from "./AsACoachAcceptedInspectionRequestsTable.vue?vue&type=template&id=c4570d18&scoped=true"
import script from "./AsACoachAcceptedInspectionRequestsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./AsACoachAcceptedInspectionRequestsTable.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AsACoachAcceptedInspectionRequestsTable.vue?vue&type=style&index=0&id=c4570d18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4570d18",
  null
  
)

export default component.exports